var render = function () {
  var _vm$bookingPreset, _vm$bookingPreset$con, _vm$bookingPreset$con2, _vm$selectedBranch, _vm$selectedStaff;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "liff-reservation-schedule"
  }, [(_vm$bookingPreset = _vm.bookingPreset) !== null && _vm$bookingPreset !== void 0 && (_vm$bookingPreset$con = _vm$bookingPreset.config) !== null && _vm$bookingPreset$con !== void 0 && (_vm$bookingPreset$con2 = _vm$bookingPreset$con.schedule_page) !== null && _vm$bookingPreset$con2 !== void 0 && _vm$bookingPreset$con2.title ? _c('h2', {
    staticClass: "wizard-mode-layout__page-title"
  }, [_vm._v(_vm._s(_vm.bookingPreset.config.schedule_page.title))]) : _vm._e(), _vm.selectedBranch || _vm.selectedStaff ? _c('h4', {
    staticClass: "text-center my-2"
  }, [_c('div', {
    staticClass: "liff-reservation-schedule__branch-staff"
  }, [(_vm$selectedBranch = _vm.selectedBranch) !== null && _vm$selectedBranch !== void 0 && _vm$selectedBranch.id ? _c('div', {
    staticClass: "liff-reservation-schedule__branch-staff__name"
  }, [_vm._v(_vm._s(_vm.deepGet(_vm.selectedBranch, 'name')))]) : _vm._e(), (_vm$selectedStaff = _vm.selectedStaff) !== null && _vm$selectedStaff !== void 0 && _vm$selectedStaff.id ? _c('div', {
    staticClass: "liff-reservation-schedule__branch-staff__img"
  }, [_vm.deepGet(_vm.selectedStaff, 'img') ? _c('img', {
    attrs: {
      "src": _vm.deepGet(_vm.selectedStaff, 'img'),
      "alt": "staff"
    }
  }) : _c('img', {
    attrs: {
      "src": require("./images/staff.png"),
      "alt": "staff"
    }
  }), _vm._v(" " + _vm._s(_vm.deepGet(_vm.selectedStaff, 'name')) + " ")]) : _vm._e()])]) : _vm._e(), _vm.selectedServices.length > 0 ? _c('h4', {
    staticClass: "text-center my-2"
  }, [_c('div', {
    staticClass: "liff-reservation-schedule__services"
  }, [_c('div', {
    staticClass: "liff-reservation-schedule__services__img"
  }, [_vm._l(_vm.selectedServices, function (img) {
    return [img.image ? _c('img', {
      key: img._id,
      attrs: {
        "src": img.image,
        "alt": "service"
      }
    }) : _vm._e()];
  })], 2), _vm._v(" " + _vm._s(_vm.selectedServices.map(function (service) {
    return service.title;
  }).join('、')) + " ")])]) : _vm._e(), _c('div', {
    staticClass: "s-mb-3"
  }, [_vm._v("請選擇日期："), _vm.date ? _c('span', [_vm._v("已選擇 " + _vm._s(_vm.selectedDateInString))]) : _vm._e()]), _c('div', {
    staticClass: "liff-reservation-schedule__date s-mb-4"
  }, [!_vm.bookingPreset || _vm.isFetchingMonthlyShifts ? _c('div', {
    staticClass: "wizard-mode-layout__loading-overlay"
  }, [_c('div', {
    staticClass: "wizard-mode-layout__loading-spinner"
  }), _c('div', {
    staticClass: "wizard-mode-layout__loading-text"
  }, [_vm._v("載入中...")])]) : _vm._e(), _c('Datepicker', {
    attrs: {
      "placeholder": "請輸入查詢開始時間",
      "format": "yyyy/MM/dd",
      "language": _vm.zh,
      "disabled-dates": {
        customPredictor: _vm.dateIsUnavailable
      },
      "calendar-class": "datepicker-calendar",
      "wrapper-class": "datepicker-wrapper",
      "bootstrap-styling": "",
      "inline": ""
    },
    on: {
      "opened": _vm.handleCalendarOpened,
      "changedMonth": _vm.handleMonthChange,
      "input": _vm.handleDateChanged
    },
    model: {
      value: _vm.date,
      callback: function callback($$v) {
        _vm.date = $$v;
      },
      expression: "date"
    }
  })], 1), !_vm.dataModel.startAtFieldFormatIsDate ? _c('div', {
    staticClass: "s-mb-3"
  }, [_vm._v(" 請選擇時間： "), _vm.time ? _c('span', [_vm._v(" 已選擇 " + _vm._s(_vm.selectedDateAndTimeLabel) + " ")]) : _vm._e()]) : _vm._e(), !_vm.dataModel.startAtFieldFormatIsDate ? _c('div', {
    staticClass: "liff-reservation-schedule__timer"
  }, [_vm.isCheckingOccupancy ? _c('div', {
    staticClass: "wizard-mode-layout__loading-overlay"
  }, [_c('div', {
    staticClass: "wizard-mode-layout__loading-spinner"
  }), _c('div', {
    staticClass: "wizard-mode-layout__loading-text"
  }, [_vm._v("載入中...")])]) : _vm._e(), _vm._l(_vm.timeOptions, function (timeOption) {
    return _c('div', {
      key: timeOption.value,
      staticClass: "liff-reservation-schedule__time-option",
      class: {
        'selected': _vm.time === timeOption.value,
        'disabled': _vm.timeIsUnavailable(timeOption.value)
      },
      on: {
        "click": function click($event) {
          return _vm.selectTime(timeOption.value);
        }
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.time,
        expression: "time"
      }],
      staticClass: "liff-reservation-schedule__time-input",
      attrs: {
        "type": "radio",
        "id": timeOption.value,
        "disabled": _vm.timeIsUnavailable(timeOption.value)
      },
      domProps: {
        "value": timeOption.value,
        "checked": _vm._q(_vm.time, timeOption.value)
      },
      on: {
        "change": function change($event) {
          _vm.time = timeOption.value;
        }
      }
    }), _c('label', {
      attrs: {
        "for": timeOption.value
      }
    }, [_vm._v(_vm._s(timeOption.text || timeOption.value))])]);
  })], 2) : _vm._e(), !_vm.isCheckingAvailability && !_vm.passedAvailabilityCheck ? _c('p', {
    staticClass: "text-danger text-center mt-3"
  }, [_vm._v("無法預約該時段")]) : _vm._e(), _c('div', {
    staticClass: "liff-reservation-schedule__notice"
  }, [_c('div', {
    staticClass: "liff-reservation-schedule__notice-divider"
  }), _c('div', {
    staticClass: "s-mb-3 s-font-medium s-pt-3"
  }, [_vm._v("注意事項")]), _c('div', {
    ref: "reservationNotes",
    staticClass: "s-text-sm s-text-gray",
    domProps: {
      "innerHTML": _vm._s(_vm.reservationNotes)
    }
  }), _c('div', {
    staticClass: "booking-tip-modal"
  }, [_vm.bookingTip ? _c('Popup', {
    ref: "bookingTipPopup",
    attrs: {
      "title": _vm.bookingTip.form_title,
      "panelHeight": "auto"
    }
  }, [_c('div', {
    staticClass: "s-mb-5"
  }, [_vm._v(" " + _vm._s(_vm.bookingTip.form_desc) + " ")]), _c('div', {
    staticClass: "s-flex s-flex-col s-space-y-2",
    attrs: {
      "slot": "actions"
    },
    slot: "actions"
  }, [_vm.bookingTip.button_top.enabled ? _c('MemberButton', {
    attrs: {
      "button-text": _vm.bookingTip.button_top.button_text,
      "type": _vm.bookingTip.button_top.button_action,
      "button-url": _vm.bookingTip.button_top.button_url
    }
  }) : _vm._e(), _vm.bookingTip.button_bottom.enabled ? [_vm.bookingTip.button_bottom.button_action == 'Exit' ? _c('SharedButton', {
    staticClass: "s-btn-outline-primary",
    on: {
      "click": function click($event) {
        return _vm.$refs.bookingTipPopup.close();
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.bookingTip.button_bottom.button_text) + " ")]) : _c('MemberButton', {
    attrs: {
      "button-text": _vm.bookingTip.button_bottom.button_text,
      "type": _vm.bookingTip.button_bottom.button_action,
      "button-url": _vm.bookingTip.button_bottom.button_url
    }
  })] : _vm._e()], 2)]) : _vm._e()], 1)]), _c('div', {
    staticClass: "wizard-mode-layout__footer-navigation"
  }, [_vm.date && (_vm.time || _vm.dataModel.startAtFieldFormatIsDate) ? _c('div', {
    staticClass: "s-flex s-justify-between s-items-center s-mb-3"
  }, [_c('div', {
    staticClass: "s-font-medium"
  }, [_c('p', [_vm._v(" 預約時間： "), _c('span', {
    staticClass: "s-text-primary"
  }, [_vm._v(" " + _vm._s(_vm.selectedDateAndTimeLabel) + " ")])]), _vm.endDateTimeForDisplay && !_vm.dataModel.shouldHideEndTime ? _c('div', [_vm._v(" 預計結束時間： "), _c('span', {
    staticClass: "s-text-primary"
  }, [_vm._v(" " + _vm._s(_vm.endDateTimeForDisplay) + " ")])]) : _vm._e()]), _c('div', {
    staticClass: "s-text-primary cursor-pointer s-font-medium s-flex-shrink-0",
    on: {
      "click": function click($event) {
        return _vm.resetDate();
      }
    }
  }, [_vm._v("重選")])]) : _vm._e(), _c('div', {
    staticClass: "wizard-mode-layout__footer-button-wrapper"
  }, [_vm.hasPreviousStep() ? _c('button', {
    staticClass: "s-btn s-liff-theme-btn-outline s-btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.handleNegativeButtonClicked
    }
  }, [_vm._v(" 上一步 ")]) : _vm._e(), _c('button', {
    staticClass: "s-btn s-liff-theme-btn s-btn-sm",
    attrs: {
      "type": "button",
      "disabled": _vm.nextStepIsDisabled
    },
    on: {
      "click": _vm.handlePositiveButtonClicked
    }
  }, [_vm._v(" " + _vm._s(_vm.textForProceedButton()) + " ")])])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }